"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var sok_ui_1 = require("@caddigital/sok-ui");
var components_1 = require("components");
var FormList_1 = require("./FormList");
var modalActions = require("@caddigital/sok-reducers/lib/actions/sokosite/configModal");
var formsActions = require("@caddigital/sok-reducers/lib/actions/sokosite/forms");
var activatedFormsActions = require("@caddigital/sok-reducers/lib/actions/sokosite/activatedForms");
var Types = require("types");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
require("./style.scss");
var mapStateToProps = function (state) {
    return {
        modal: state.sokosite.configModal,
        forms: state.sokosite.forms,
        activatedForms: state.sokosite.activatedForms
    };
};
var mapDispatchToProps = function (dispatch) { return ({
    fetchForms: function () { return dispatch(formsActions.fetchRequest()); },
    fetchActivatedForms: function (projectId) {
        return dispatch(activatedFormsActions.fetchRequest(projectId));
    },
    activateForms: function (payload) {
        return dispatch(activatedFormsActions.activateFormsRequest(payload));
    },
    toggleModal: function () { return dispatch(modalActions.toggleModal()); },
    clear: function () { return dispatch(modalActions.clear()); }
}); };
var statePropsExtractable = Types.extractReturnType(mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(mapDispatchToProps);
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps), (0, recompose_1.withState)('selected', 'setSelected', []), (0, recompose_1.withState)('addedForms', 'setAddedForms', []), (0, recompose_1.lifecycle)({
    componentDidMount: function () {
        this.props.fetchForms();
        if (this.props.modal.isOpen) {
            this.props.fetchActivatedForms(this.props.projectId.toString());
        }
    },
    componentDidUpdate: function (prevProps) {
        if (this.props.modal.isOpen !== prevProps.modal.isOpen) {
            if (this.props.modal.isOpen) {
                this.props.fetchActivatedForms(this.props.projectId.toString());
            }
            else {
                this.props.clear();
            }
        }
        if (this.props.activatedForms.status !== prevProps.activatedForms.status &&
            this.props.activatedForms.status === 'UPDATED') {
            this.props.fetchActivatedForms(this.props.projectId.toString());
        }
        if (this.props.activatedForms.activatedForms !==
            prevProps.activatedForms.activatedForms) {
            this.props.setAddedForms(this.props.activatedForms.activatedForms);
        }
    },
    componentWillUnmount: function () {
        this.props.clear();
    }
}), recompose_1.pure);
var handleSave = function (props) {
    var activateForms = props.addedForms.map(function (form) {
        return form.uuid ? form.uuid : '';
    });
    var payload = {
        projectId: props.projectId.toString(),
        activate_forms: props.addedForms.length > 0 ? activateForms : []
    };
    props.activateForms(payload);
    props.setSelected([]);
};
exports.default = enhance(function (props) {
    return (React.createElement(sok_ui_1.Modal, { className: 'sokosite-configuration-modal', isOpen: props.modal.isOpen },
        React.createElement(sok_ui_1.Header, { onClose: function () { return props.toggleModal(); } }, (0, translation_1.getLocalization)('sokosite/configModal/header')),
        React.createElement(sok_ui_1.Container, null,
            React.createElement(sok_ui_1.Grid.Row, { className: "grid-row" },
                React.createElement(sok_ui_1.Button, { color: "green", className: "add-button", size: "medium", text: (0, translation_1.getLocalization)('sokosite/configModal/addSelected'), disabled: props.selected.length === 0, onClick: function () {
                        return props.setAddedForms(props.addedForms.concat(props.selected));
                    } })),
            React.createElement(sok_ui_1.Grid.Row, { className: "list-row" },
                React.createElement(sok_ui_1.Grid.Column, { medium: 9 },
                    React.createElement(FormList_1.default, { selected: props.selected, setSelected: props.setSelected, formList: props.forms.forms, activatedForms: props.activatedForms.activatedForms })),
                React.createElement(sok_ui_1.Grid.Column, { medium: 3 },
                    React.createElement("div", { className: "sokosite-modal-addedforms" },
                        React.createElement(sok_ui_1.Table.Table, { className: 'striped hovered' },
                            React.createElement(sok_ui_1.Table.Head, { className: "sokosite-modal-list-header" },
                                React.createElement(sok_ui_1.Table.Row, null,
                                    React.createElement(sok_ui_1.Table.Column, null, (0, translation_1.getLocalization)('sokosite/configModal/addedForms')),
                                    React.createElement(sok_ui_1.Table.Column, null))),
                            React.createElement(sok_ui_1.Table.Body, null, props.addedForms.map(function (data) {
                                return (React.createElement(sok_ui_1.Table.Row, { key: data.uuid },
                                    React.createElement(sok_ui_1.Table.Column, { className: "added-forms-text-column" }, data.name),
                                    React.createElement(sok_ui_1.Table.Column, { className: "added-forms-icon-column" },
                                        React.createElement(components_1.TableRowIcon, { icon: 'fa-times-circle', className: 'red', onClick: function () {
                                                props.setAddedForms(__spreadArray([], props.addedForms, true).filter(function (form) { return form.uuid !== data.uuid; }));
                                            } }))));
                            })))))),
            React.createElement(sok_ui_1.Footer, null,
                React.createElement("div", { className: "button-container" },
                    React.createElement(sok_ui_1.Button, { color: "green", className: "save-button", text: (0, translation_1.getLocalization)('sokosite/configModal/save'), disabled: props.addedForms === props.activatedForms.activatedForms, onClick: function () { return handleSave(props); } }),
                    React.createElement(sok_ui_1.Button, { color: "dark-gray", className: "cancel-button", text: (0, translation_1.getLocalization)('sokosite/configModal/cancel'), onClick: function () { return props.toggleModal(); } }))))));
});
